/** Raids (v1 ticket 47): the small templates its screens share. */
import { html, nothing } from 'lit';
import { t } from '../../i18n';
import { FORM_ICON } from './raid-army';
import { tParts } from '../../bidi-html';
import type { Aim, Form, Material } from './raid-api';

/** One of the learner's own words: Finglish first for a Persian word, its script after. */
export function wordOf(w: { text: string; latin?: string }) {
  return w.latin
    ? html`<bdi class="ca" dir="ltr">${w.latin}</bdi> <bdi class="ca rk-script" dir="auto">${w.text}</bdi>`
    : html`<bdi class="ca" dir="auto">${w.text}</bdi>`;
}

/** A friend's name, isolated. */
export const nameOf = (name: string) => html`<bdi dir="auto">${name}</bdi>`;

/** What a weapon is: its form's icon and name with its material ("🪨 A stone catapult"). */
export function strikeOf(form: Form, material: Material) {
  return html`<span class="rk-strike"><span aria-hidden="true">${FORM_ICON[form]}</span> <span class="rk-strike-text">${t(`raid.strike.${form}`, { material: t(`raid.mat.${material}`) })}</span></span>`;
}

/**
 * The district a raid aims at (v1 ticket 48): "District 3" for the attacker, the defender's own district by its real
 * title in an isolate. Nothing when the raid has none (one from before districts).
 */
export function aimLine(aim: Aim | undefined, className = 'rk-aim') {
  if (aim?.title) return html`<p class="${className} muted small">${tParts('raid.aimedAtOwn', { title: html`<bdi dir="auto">${aim.title}</bdi>` })}</p>`;
  if (aim?.slot) return html`<p class="${className} muted small">${t('raid.aimedAt', { n: aim.slot })}</p>`;
  return nothing;
}

/** A district in a list: "District 3" (the attacker's) or the defender's own title. */
export function aimName(aim: Aim | undefined) {
  if (aim?.title) return html`<bdi dir="auto">${aim.title}</bdi>`;
  return aim?.slot ? t('raid.districtN', { n: aim.slot }) : nothing;
}
